import { Suspense, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import LoadingSpinner from '@/components/LoadingSpinner'

const DentinAndEnamel = lazy(
  async () => import('@/pages/getRecipe/matisseLite/dentin&enamel'),
)
const StainingStudio = lazy(
  async () => import('@/pages/getRecipe/matisseLite/stainingCorrection'),
)

const MatisseLiteRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="dentin_enamel" element={<DentinAndEnamel />} />
        <Route path="staining-studio" element={<StainingStudio />} />
      </Routes>
    </Suspense>
  )
}

export default MatisseLiteRoutes
